import { render, staticRenderFns } from "./AlertInfoPage.vue?vue&type=template&id=14ca68b6&scoped=true&"
import script from "./AlertInfoPage.vue?vue&type=script&lang=js&"
export * from "./AlertInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca68b6",
  null
  
)

export default component.exports